export { default } from './InputSelectFetchData'
